import React from 'react';
import { wrap } from './style';
interface Props {
  title: string;
  required?: boolean;
}

function FilterTitle({ title, required }: Props) {
  return (
    <p css={wrap}>
      {title}
      {required && (
        <span
          css={{
            color: '#F04452',
            paddingLeft: '2px',
          }}
        >
          *
        </span>
      )}
    </p>
  );
}

export default FilterTitle;
